import { Link, useNavigate } from "react-router-dom";
import { jt, t } from "ttag";

import { ROUTES } from "@/app/router";
import { INTAKE_FORM_ROUTE } from "@/features/intake-form/router";
import type { Subscription } from "@/shared/domains";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, Dialog, HeartsIcon } from "@/shared/ui";

interface PaymentSuccessModalProps extends ModalProps {
  subscription: Subscription;
}

export const PaymentSuccessModal = ({
  show,
  onClose,
  subscription,
}: PaymentSuccessModalProps) => {
  const navigate = useNavigate();

  const handleGoToIntake = () => {
    return navigate(INTAKE_FORM_ROUTE.CHOOSE_JOURNEY, {
      state: subscription,
    });
  };

  const intakeFormStrong = (
    <strong key="intake-form-strong" className="underline">
      {t`intake form`}
    </strong>
  );

  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={HeartsIcon}>
          <Dialog.Title>{t`Payment successfully processed!`}</Dialog.Title>
          <Dialog.Description>
            {t`Your payment has been processed correctly.`}
            {!subscription.intakeFormCompleted && (
              <>
                {" "}
                {jt`Please complete the ${intakeFormStrong} to be able to join video consultations or order medication.`}
              </>
            )}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer className="pt-6">
          <Button
            size="lg"
            variant={subscription.intakeFormCompleted ? "primary" : "secondary"}
            asChild
          >
            <Link to={ROUTES.BASE}>{t`Go to Home`}</Link>
          </Button>

          {!subscription.intakeFormCompleted && (
            <Button size="lg" onClick={handleGoToIntake}>
              {t`Go to intake`}
            </Button>
          )}
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
